import React from "react";

export default class HeroErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("Hero failed to render, showing fallback:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section
          id="hero"
          data-testid="hero-fallback"
          className="relative min-h-screen w-full flex flex-col items-center justify-center text-center px-6"
          style={{ background: "radial-gradient(ellipse 80% 60% at 50% 42%, #131313 0%, #0A0A0A 65%)" }}
        >
          <span className="section-label text-[11px] text-[#6ea8ff] mb-8">
            Mind Before Markets, Melbourne, AU
          </span>
          <h1 className="font-heading text-5xl sm:text-7xl font-light tracking-tighter text-white">
            MASTER YOUR MIND.
            <br />
            MASTER THE <span className="blue-text">MARKETS.</span>
          </h1>
          <p className="mt-8 text-base lg:text-xl text-zinc-400 font-light max-w-xl">
            Master the trader within. The markets will follow.
          </p>
          <div className="mt-12 flex flex-col sm:flex-row items-center gap-4">
            <a href="#apply" className="btn-solid px-9 py-4 text-sm font-medium tracking-wide" data-testid="fallback-join-btn">
              Join the Academy
            </a>
            <a href="#programs" className="btn-glass text-white px-9 py-4 text-sm font-medium tracking-wide" data-testid="fallback-hub-btn">
              Explore Trading Hub
            </a>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
